import { Box, Grid } from '@mui/material';
import { Checkbox } from 'library';
import React from 'react';

export default function FilterCheckboxList({
    options,
    selectedOptions,
    onChange,
}: {
    options: string[];
    selectedOptions: string[];
    onChange: (x: string) => void;
}) {
    return (
        <Grid item xs={12}>
            <Box style={{ marginTop: '3%' }}>
                <Grid item container direction="row" style={{ gap: 10 }}>
                    {options.map((x) => (
                        <Checkbox
                            key={x}
                            label={x}
                            checked={selectedOptions.includes(x)}
                            onChange={() => onChange(x)}
                        />
                    ))}
                </Grid>
            </Box>
        </Grid>
    );
}
